var render = function render(){var _vm=this,_c=_vm._self._c;return _c('jsk-text',_vm._b({attrs:{"text-type":_vm.linkType,"is-link":""}},'jsk-text',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }